export default __webpack_public_path__ + "f7125c9cc8385e68d98001ff9a11bbfe.png";